// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

import Help from 'components/help/help';

import './help_popout.scss';

export default function HelpPopout() {
    return (
        <div className='HelpPopout'>
            <Help/>
        </div>
    );
}
